import request from './request'

export function syncAdvertiserDailyReports(data) {
  return request({
    url: '/tiktok/advertiser-daily-report/sync',
    method: 'post',
    withCredentials: false,
    data
  })
}

export function queryAdvertiserDailyReports(params) {
  return request({
    url: '/tiktok/advertiser-daily-report/records',
    method: 'get',
    withCredentials: false,
    params
  })
}
